var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isVisible
    ? _c(
        "div",
        {
          staticClass: "gfu-grid__cell gfu-1of3",
          attrs: { "data-qa": `filtersbox-field:${_vm.displayName}` },
        },
        [
          _c(
            "number-field",
            _vm._b(
              {
                attrs: {
                  value: _vm.value,
                  "label-class": "gfu-field__label--gray",
                  small: true,
                  "text-align": "left",
                },
                on: {
                  input: _vm.onInput,
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.applyFilter.apply(null, arguments)
                  },
                },
              },
              "number-field",
              { ..._vm.$attrs, ..._vm.$props },
              false
            )
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }